import { render, staticRenderFns } from "./SxhmatismosMenu.vue?vue&type=template&id=32cce860&scoped=true"
import script from "./SxhmatismosMenu.vue?vue&type=script&lang=js"
export * from "./SxhmatismosMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cce860",
  null
  
)

export default component.exports